/** 会员面板共享的轻量格式化工具（避免各子组件重复实现） */

/** 格式化为「YYYY年MM月DD日」 */
export function fmtDate(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  return `${date.getFullYear()}年${String(date.getMonth() + 1).padStart(2, '0')}月${String(date.getDate()).padStart(2, '0')}日`;
}

/** 格式化为「YYYY-MM-DD HH:mm」 */
export function fmtDateTime(d: string): string {
  const date = new Date(d);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

/** 金额格式化：去掉多余小数（¥199 而非 ¥199.00），保留必要小数（¥19.9） */
export function fmtPrice(v: number | string | null | undefined): string {
  const n = Number(v ?? 0);
  if (!Number.isFinite(n)) return '0';
  return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/0$/, '');
}
